import { render, staticRenderFns } from "./PushForm.vue?vue&type=template&id=28703cdf&scoped=true&"
import script from "./PushForm.vue?vue&type=script&lang=js&"
export * from "./PushForm.vue?vue&type=script&lang=js&"
import style0 from "./PushForm.vue?vue&type=style&index=0&id=28703cdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28703cdf",
  null
  
)

export default component.exports